import { ReactElement } from 'react';

type IfProps = {
	condition: boolean;
	children: ReactElement;
};

export const IF = ({ condition, children }: IfProps): ReactElement | null => {
	if (condition) {
		return children;
	}
	return null;
};
